import { normalizeModel } from '../../utils/normalize'
import { extend } from 'quasar'

const defaultGetters = {
  list: state => (state.records && state.records.length ? state.records : []),
  find: (state, getters) => id => getters.list.find(r => r.id === id),
  namespace: state => state.namespace,
  apiEndpoint: state => relatedId => {
    if (relatedId && state.parentResource) {
      return `${state.parentResource}/${relatedId}${state.apiEndpoint}`
    }
    return state.apiEndpoint
  },
  relations: (state, getters) => getters.columns.filter(c => c.relation && c.relation.namespace && c.relation.namespace !== state.namespace) || [],
  settings: state => state.settings,
  selectedRows: (state, getters) => getters.settings.selected,
  filters: (state, getters) => getters.settings.filters,
  filterColumns: (state, getters) => getters.filters.columns,
  layout: state => state.settings.layout,
  columns: state => state.columns,
  columnsByField: state => state.columns.reduce((obj, column) => Object.assign(obj, { [column.field]: column }), {}),
  column: (state, getters) => field => getters.columnsByField[field],
  defaultColumns: (state, getters) => {
    return getters.columns.filter(col => (col.visible || col.required) && (col !== null && col !== undefined && col.field) && (col.component && col.component.is) && col.field !== 'action')
  },
  visibleColumns: (state, getters) => {
    if (getters.settings.visibleColumns.length) {
      return getters.settings.visibleColumns.map(c => getters.column(c)).filter(c => c !== null && c !== undefined && c.field)
    }
    return getters.columns.filter(col => (col.visible || col.required) && (col !== null && col !== undefined && col.field))
  },
  titleColumn: (state, getters) => (state.titleColumn ? getters.columnsByField[state.titleColumn] : state.columns[0]),
  subtitleColumn: (state, getters) => (state.subtitleColumn ? getters.columnsByField[state.subtitleColumn] : undefined),
  infoColumns: (state, getters) => (state.infoColumns.length ? state.infoColumns.map(field => getters.columnsByField[field]) : []),
  search: (state, getters) => getters.filters.search || [],
  countTotal: state => state.records.length || 0,
  pagination: (state, getters) => {
    const defaultPagination = {
      sortBy: null,
      descending: false,
      page: 1,
      rowsPerPage: 25,
      rowsNumber: 25
    }
    const runTime = {
      rowsNumber: getters.countTotal
    }
    return extend(true, {}, defaultPagination, state.settings.pagination, runTime)
  },
  groupedByField: (state, getters) => getters.settings.groupedByField,
  // parentFakeColumns: (state, getters, rootState) => (state.parentResource && rootState[state.parentResource] ? rootState[state.parentResource].fakeColumns : []),
  // parentColumns: (state, getters, rootState, rootGetters) => (state.parentResource ? rootGetters[state.parentResource] : []),
  // model: (state, getters) => normalizeModel(getters.columns, {}, getters.parentFakeColumns)
  model: (state, getters) => normalizeModel(getters.columns, {}, state)
}

export default gt => {
  return extend(true, {}, defaultGetters, gt)
}
